<script>
    export default {
        props: {
			notificationDetails: Array
        },
        data() {
            return {
                
            }    
        }
    }
</script>

<template>
    <div class="card">
        <div class="card-title p-3 pt-2 mb-0" style="margin-bottom: -30px !important;">Notifications (Manage the emails you receive.)</div>
        <div class="card-body">
            <span class="text-secondary">You will Always Receive Payment Notifications</span>
            <div class="row mt-2">
                <div 
                    v-for="(item, index) in notificationDetails"
                    class="col-12 col-lg-6 col-md-6 px-4 form-check"
                    :key="index"
                >
                    <input 
                        :id="item.key"
                        type="checkbox"
                        v-model="item.isChecked"
                        class="form-check-input"
                    />
                    <label 
                        class="form-check-label"
                        :for="item.key"
                    >
                        {{ item.value }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>